import { motion, AnimatePresence, animate, delay } from "framer-motion"
import { useState, useEffect } from "react";
import { useDocumentLoadCompleted } from "../Hooks";
import { useLocation } from "react-router-dom";

const MotionRoute = (props) => {

  const isLoaded = useDocumentLoadCompleted();
  const location = useLocation().pathname.replace('ones', '');

  return(
    <>
      <motion.div
        animate={ isLoaded && {
          opacity: 1
        }}
        initial={{
          opacity: 0
        }}
        exit={{
          opacity: 0
        }}
        transition={{
          duration: 0.4,
          // delay: location == '/' ? 1 : 0,
        }}
        onAnimationComplete={() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          });
        }}
      >

        { props.children }
      </motion.div>
    </>
  )
}

export default MotionRoute;
